// extracted by mini-css-extract-plugin
export default {"gradient":"SectionGradient_gradient__XAAAT","bg":"SectionGradient_bg__iY357"};